module.exports = __webpack_public_path__ + "img/news8-2.fb9626bd.png";